import apiClient from './api';

export interface User {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  phone?: string;
  role: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserUpdate {
  first_name: string;
  last_name: string;
  phone?: string;
}

export interface PasswordUpdate {
  current_password: string;
  new_password: string;
}

export interface SmtpConfig {
  smtp_host: string | null;
  smtp_port: number | null;
  smtp_user: string | null;
  smtp_from: string | null;
  is_configured: boolean;
}

export interface SmtpConfigUpdate {
  smtp_host: string;
  smtp_port: number;
  smtp_user: string;
  smtp_password: string;
  smtp_from: string;
}

export interface SmtpTestRequest extends SmtpConfigUpdate {}

export interface SignatureResponse {
  signature: string | null;
  default_signature: string;
}

export const userService = {
  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/users/me');
    return response.data;
  },

  updateMe: async (data: UserUpdate): Promise<User> => {
    const response = await apiClient.put<User>('/users/me', data);
    return response.data;
  },

  changePassword: async (data: PasswordUpdate): Promise<void> => {
    await apiClient.put('/users/me/password', data);
  },

  getVeterinarians: async (): Promise<User[]> => {
    const response = await apiClient.get<User[]>('/users/veterinarians');
    return response.data;
  },

  getAllVeterinarians: async (): Promise<User[]> => {
    const response = await apiClient.get<User[]>('/users/veterinarians');
    return response.data;
  },

  getSignature: async (): Promise<SignatureResponse> => {
    const response = await apiClient.get<SignatureResponse>('/users/me/signature');
    return response.data;
  },

  updateSignature: async (signature: string): Promise<SignatureResponse> => {
    const response = await apiClient.put<SignatureResponse>('/users/me/signature', { signature });
    return response.data;
  },

  deleteSignature: async (): Promise<void> => {
    await apiClient.delete('/users/me/signature');
  },

  getSmtpConfig: async (): Promise<SmtpConfig> => {
    const response = await apiClient.get<SmtpConfig>('/users/me/smtp-config');
    return response.data;
  },

  updateSmtpConfig: async (config: SmtpConfigUpdate): Promise<SmtpConfig> => {
    const response = await apiClient.put<SmtpConfig>('/users/me/smtp-config', config);
    return response.data;
  },

  deleteSmtpConfig: async (): Promise<void> => {
    await apiClient.delete('/users/me/smtp-config');
  },

  testSmtpConfig: async (config: SmtpTestRequest): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.post<{ success: boolean; message: string }>(
      '/users/me/smtp-config/test',
      config
    );
    return response.data;
  },

  testSavedSmtpConfig: async (): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.get<{ success: boolean; message: string }>(
      '/users/me/smtp-config/test'
    );
    return response.data;
  },
};
